import { KsefOutgoingEligibilityInputDto } from '../Types/ksefOutgoing.types';

export interface KsefOutgoingPayloadForm {
  buyerCountryIso: string | null;
  buyerNip: string | null;
  isBuyerVatEu: '' | 'true' | 'false' | null;
  eligibilityOverride: 'none' | 'forceExclude' | 'forceInclude';
  operatorDecisionReason: string;
}

export interface KsefOutgoingEligibilityInputSource {
  buyerCountryIso?: string | null;
  buyerNip?: string | null;
  isBuyerVatEu?: boolean | null;
}

export const defaultKsefOutgoingPayloadForm: KsefOutgoingPayloadForm = {
  buyerCountryIso: null,
  buyerNip: null,
  isBuyerVatEu: null,
  eligibilityOverride: 'none',
  operatorDecisionReason: '',
};

const normalizeOperatorText = (value: string | null): string | null => {
  if (value === null) {
    return null;
  }

  const trimmed = value.trim();
  return trimmed ? trimmed : null;
};

const normalizeSourceText = (value?: string | null): string | null => {
  const trimmed = value?.trim();
  return trimmed ? trimmed : null;
};

const normalizeOperatorCountryIso = (value: string | null): string | null => {
  const normalized = normalizeOperatorText(value);
  return normalized === null ? null : normalized.toUpperCase();
};

const normalizeSourceCountryIso = (value?: string | null): string | null => {
  const normalized = normalizeSourceText(value);
  return normalized ? normalized.toUpperCase() : null;
};

export const buildEligibilityInput = (
  form: KsefOutgoingPayloadForm,
  source?: KsefOutgoingEligibilityInputSource
): KsefOutgoingEligibilityInputDto | undefined => {
  if (form.eligibilityOverride === 'none') {
    return undefined;
  }

  const shouldUseSourceVatEu = form.isBuyerVatEu === null || form.isBuyerVatEu === '';
  const normalizedOperatorBuyerCountryIso = normalizeOperatorCountryIso(form.buyerCountryIso);
  const normalizedOperatorBuyerNip = normalizeOperatorText(form.buyerNip);
  const buyerCountryIso =
    normalizedOperatorBuyerCountryIso === null
      ? normalizeSourceCountryIso(source?.buyerCountryIso)
      : normalizedOperatorBuyerCountryIso;
  const buyerNip =
    normalizedOperatorBuyerNip === null
      ? normalizeSourceText(source?.buyerNip)
      : normalizedOperatorBuyerNip;
  const operatorDecisionReason = form.operatorDecisionReason.trim();

  const isBuyerVatEu =
    shouldUseSourceVatEu
      ? typeof source?.isBuyerVatEu === 'boolean'
        ? source.isBuyerVatEu
        : undefined
      : form.isBuyerVatEu === 'true';

  const payload: KsefOutgoingEligibilityInputDto = {
    eligibilityOverride: form.eligibilityOverride,
  };

  if (buyerCountryIso) {
    payload.buyerCountryIso = buyerCountryIso;
  }

  if (buyerNip) {
    payload.buyerNip = buyerNip;
  }

  if (typeof isBuyerVatEu === 'boolean') {
    payload.isBuyerVatEu = isBuyerVatEu;
  }

  if (operatorDecisionReason) {
    payload.operatorDecisionReason = operatorDecisionReason;
  }
  return payload;
};
